<template>
  <div style="position: absolute; right:20px; top:48px;">
      <select
          class="btn"
          v-model="language"
          ref="language"
          @input="setLanguage"
          title="language"
      >
        <option
            v-for="(item,key) in items"
            :key="key"
            :value="item.value"
        >
          {{ item.name }}
        </option>
      </select>
  </div>
</template>

<script>
export default {
  name: "Language",
  data () {
    return {
      language: 0,
      items: [
        {
          value: "0",
          name: "DE"
        },
        {
          value: "1",
          name: "FR"
        },
        {
          value: "2",
          name: "EN"
        }
      ]
    }
  },
  methods: {
    setLanguage() {
      let sel = this.$refs.language.value
      this.$store.commit('setLanguage', sel)
      this.emitter.emit('reloadLegend','reloadLegend')
    }
  }
}
</script>

<style scoped>
.active {
  background-color: aquamarine;
}
select {
  -webkit-appearance: button;
  -moz-appearance: button;
  -webkit-user-select: none;
  -moz-user-select: none;
  -webkit-padding-end: 2px;
  -moz-padding-end: 2px;
  -webkit-padding-start: 2px;
  -moz-padding-start: 2px;
  background-color: white;
  background-position: center right;
  background-repeat: no-repeat;
  border: 1px solid #7f7f7f;
  border-radius: 2px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
  color: #2f2f2f;
  font-size: 13px;
  margin: 0;
  padding-top: 0px;
  padding-bottom: 0px;
  /*text-overflow: ellipsis;*/
  white-space: nowrap;
}
.btn {
  height: 28px;
  box-shadow: 2px 2px 7px #777777;
  border-radius: 1px;
  background-color: #cccccc;
  font-weight: bold;
  font-size: 14pt;
  cursor: pointer;
  background-color: white;
}

.hoverable:hover {
  opacity: 0.7;
}



</style>
